export enum FormFields {
  Password = 'password',
  PasswordConfirmation = 'password_confirmation',
}

export interface FormValues {
  [FormFields.Password]?: string;
  [FormFields.PasswordConfirmation]?: string;
}
